<div class="modal-header d-flex justify-content-between align-items-center mt-4 p-2 pb-0 mx-lg-4 mx-3">
    <h4 class="fs-24 fw-500 lh-28 m-0">Manage Site</h4>
    <button type="button" class="close btn-close fs-20" aria-label="Close" (click)="closeModal()">
        <span aria-hidden="true" class="visually-hidden">&times;</span>
    </button>
</div>
<div class="modal-body p-2 pt-0 mx-lg-4 mx-3">
    <form [formGroup]="clientSites">
        <div class="row mt-4">
            <div class="col-12 col-lg-12 mb-3"
                [ngClass]="clientSites.controls['name'].dirty && clientSites.controls['name'].invalid ? 'invalid-input' : '' ">
                <label class="form-label fs-16 fw-500 lh-22">Client Name</label>
                <input type="text" class="form-control form-control-lg" placeholder="Speaker Name"
                    formControlName="name" readonly />
                @if (clientSites.controls['name'].dirty && clientSites.controls['name'].errors) {
                <div class="text-danger fs-14">
                    @if (clientSites.controls['name'].errors['required']) {
                    <div>
                        Client name is required
                    </div>
                    }
                </div>
                }
            </div>

            <div class="col-12 col-lg-12 mb-3" [ngClass]="clientSites.controls['sites'].dirty && clientSites.controls['sites'].invalid ?
          'invalid-input': '' ">
                <label class="form-label fs-16 fw-500 lh-22">Select Sites</label>
                <ng-select formControlName="sites" class="custom" [items]="allSite" bindLabel="site_name"
                    bindValue="_id" placeholder="Select Site" [clearable]="false" [multiple]="true">
                </ng-select>
                @if (clientSites.controls['sites'].dirty &&
                clientSites.controls['sites'].errors) {
                <div class="text-danger fs-14">
                    @if (clientSites.controls['sites'].errors['required']) {
                    <div>
                        Site is required
                    </div>
                    }
                </div>
                }
            </div>

        </div>
        <div class="btn-toolbar justify-content-center py-3">
            <div>
                <button type="button" class="btn btn-primary text-light py-2 px-3 px-lg-5"
                    (click)="closeModal()">Discard</button>
            </div>
            <div class="ml-10">
                <button type="button" class="btn btn-dark py-2 px-lg-5 px-4" (click)="manageAddUpdateClientSites()"
                    [disabled]="isLoading">Save</button>
            </div>
        </div>
    </form>
</div>